import React from 'react'

export const MoreActionsIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <circle cx="8" cy="3" r="1" />
    <circle cx="8" cy="8" r="1" />
    <circle cx="8" cy="13" r="1" />
  </svg>
)
